import { createContext, useContext, type ReactNode } from 'react';

/**
 * 共享组件里的少量界面文案。默认简体中文（管理后台不注入，保持中文）；
 * 用户端（apps/web）按当前语言注入一份翻译。
 */
export interface UiStrings {
  close: string;
  copied: string;
  copyValue: (value: string) => string;
  toggleSidebar: string;
  succeeded: string;
  failed: string;
  timelineSameId: string;
  /** 状态码 → 文案；返回 undefined 时用组件内置的中文 */
  status: (status: string) => string | undefined;
  site: (site: 'cn' | 'global') => string | undefined;
}

export const DEFAULT_UI_STRINGS: UiStrings = {
  close: '关闭',
  copied: '已复制',
  copyValue: (v) => `复制 ${v}`,
  toggleSidebar: '展开/收起侧栏',
  succeeded: '成功',
  failed: '失败',
  timelineSameId: '同一任务 ID · 全程不变',
  status: () => undefined,
  site: () => undefined,
};

const Ctx = createContext<UiStrings>(DEFAULT_UI_STRINGS);

export function UiStringsProvider({ value, children }: { value: UiStrings; children: ReactNode }) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useUiStrings(): UiStrings {
  return useContext(Ctx);
}

/** 在 JSX 里直接放一段共享文案（不必为此把组件改成读 hook） */
export function UiText({ k }: { k: 'close' | 'copied' | 'toggleSidebar' | 'succeeded' | 'failed' | 'timelineSameId' }) {
  return <>{useUiStrings()[k]}</>;
}
